/*
 * @Description: 
 * @Author: dezhi
 * @Date: 2019-08-26 09:11:29
 * @LastEditTime: 2021-05-11 09:39:43
 * @LastEditors: zhaoshuai
 */
// const api2 = 'http://192.168.4.40:26040/v1.0.0/';
// const api2 = 'http://192.168.4.110:26040/v1.0.0/';
// axios.defaults.headers.common['X_AUTH_TOKEN'] = localStorage.getItem("token");
import axios from "../../http";
const state = {
    studentInfo: {}
}

// getters
const getters = {

}

// actions
const actions = {
    async updateBookAction({ dispatch }, payload) {
        const res = await axios.post(`/v1.0.0/exammgr/enrollInfo/updateDeclareUrlById/${JSON.parse(localStorage.getItem("studentInfo")).enrollInfoId}`, payload)
        let userInfo = JSON.parse(localStorage.getItem("second_userInfo"));
        dispatch('getStudentInfo', {
            orderCode: userInfo.orderCode,
            userCode: userInfo.userCode,
            examCode: userInfo.examCode,
        })
        return res;
    },
    /**
     * @description: 获取订单状态
     * @param {type} 
     * @return: 
     */
     // eslint-disable-next-line
     async getOrderInfoAct({ commit, rootState }, payload) {
        const res = await axios.get(
            '/v1.0.0/order/examOrder/selectOrderList',
          {
            params: {
                userCode:JSON.parse(localStorage.getItem("second_userInfo")).userCode ,
                mobile:JSON.parse(localStorage.getItem("second_userInfo")).mobile,
                ...payload
            },
        }
        )
        return res
    },
     /**
    * @description: 查询用户证书数据
    * @param {*}
    * @return {*}
    */
     // eslint-disable-next-line
      async createPayCodeAct({ commit, rootState }, payload) {
        const data  = await axios.post(
            `/v1.0.0/order/examOrder/wechatNative`,
          
           payload,
          
        )

        return data
    },
    /**
     * @description: 更新订单状态
     * @param {type} 
     * @return: 
     */
     async getWxpayStrAct(payload) {
        const res = await axios.post(
           '/v1.0.0/order/luxun/lxcoupon/orders',
          
            payload
         
        )
        return res
    },
      /**
     * @description: 获取支付用的微信openid
     * @param {type} 
     * @return: 
     */
       async getWeOpenidAct(payload) {
        // const res = await axios.post(`/v1.0.0/order/product/weChatPayment/getOpenId`, payload)
        const res = await axios.post(
            `/v1.0.0/order/luxun/lxcoupon/getOpenId`,
          
            payload,
          
        )
        return res
    },
     /**
     * @description: 获取价格状态
     * @param {type} 
     * @return: 
     */
      // eslint-disable-next-line
      async getOrderPriceAct({ commit, rootState },preload) {
        const res = await axios.get(
            '/v1.0.0/order/product/productpackage/packageInfo',
          {
            params: {
               ...preload
            },
        }
        )
        return res
    },
     /**
    * @description: 创建订单
    * @param {type} 
    * @return: 
    */
   // eslint-disable-next-line
      async createOrderAct({ commit, rootState },payload) {
        const res = await axios.post(
            '/v1.0.0/order/examOrder/insertExam',
       
            payload
          
        )
      
        return res
    },
      /**
    * @description: 发送短信
    * @param {type} 
    * @return: 
    */
   // eslint-disable-next-line
   async sendNoteAct({ commit, rootState },payload) {
    const res = await axios.post(
        '/v1.0.0/exammgr/enrollInfo/saveAndSms',
   
        payload
      
    )
  
    return res
},
}


// mutations

const mutations = {
    saveStudentInfo(state, payload) {
        // state.classInfo = state.infoList[payload - 1];
        state.studentInfo = payload;
    }
}



export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}